export const EntityType = {
  VisitNote: 24,
  NonvisitNote: 25,
  MedOrder: 26,
  DiscontinueMedOrder: 27,
  ImagingOrder: 28,
  CardiacOrder: 29,
  SleepOrder: 30,
  PulmonaryOrder: 31,
  ReferralOrder: 32,
  LabOrder: 33,
  Report: 40,
  MessageThread: 91,
  Letter: 218,
  RxHistoryDownloadSummary: 222,
  VisitNoteSummary: 266,
  VitalsCollection: 272,
  XmlPatientSummary: 315,
} as const
export type EntityType = (typeof EntityType)[keyof typeof EntityType]

/* Elation EntityTypes that map to MedicationRequest in FHIR. */
export const MED_ORDER_TYPES: ReadonlySet<EntityType> = new Set([
  EntityType.MedOrder,
  EntityType.DiscontinueMedOrder,
])

/* All Elation EntityTypes that represent orders (both MedicationRequest and ServiceRequest in FHIR). */
export const ORDER_ENTITY_TYPES: ReadonlySet<EntityType> = new Set([
  EntityType.MedOrder,
  EntityType.DiscontinueMedOrder,
  EntityType.ImagingOrder,
  EntityType.CardiacOrder,
  EntityType.SleepOrder,
  EntityType.PulmonaryOrder,
  EntityType.ReferralOrder,
  EntityType.LabOrder,
])
